export default __webpack_public_path__ + "static/media/icon-Hub-Models.2779c053.svg";